// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.Series = Backbone.RelationalModel.extend({
    initialize: function(options) {
      var _this = this;
      if (!options || !options.colorScheme || !options.dataPerspective) {
        throw "InvalidConstructorArgs - Series";
      }
      _.bindAll(this, "bindEnums", "cleanTrendReferences", "unbindEnumsFromAttributes", "toJSON");
      this.bindEnums();
      this.fetchTrendData();
      this.on("change:trend", function(series, options) {
        _this.cleanTrendReferences();
        _this.fetchTrendData();
      });
    },
    fetchTrendData: function() {
      this.get("trend").get("slicers").fetch();
      if (!this.get("trend").isGATrend()) {
        this.get("trend").fetchMinTime();
      }
    },
    bindEnums: function() {
      return this.set({
        colorScheme: rjm.app.enums.colorScheme[this.get("colorScheme")],
        dataPerspective: rjm.app.enums.dataPerspective[this.get("dataPerspective")]
      });
    },
    unbindEnumsFromAttributes: function(attributes) {
      attributes.colorScheme = attributes.colorScheme.serializedValue;
      attributes.dataPerspective = attributes.dataPerspective.serializedValue;
      attributes.trend = attributes.trend;
      return attributes;
    },
    cleanTrendReferences: function() {
      var categorySids, newTrendSids, restrictionSids;
      newTrendSids = this.get("trend").get("slicers").pluck("sid");
      categorySids = this.get("categorySet").get("categorySelectors").map(function(selector) {
        return selector.get("column").get("sid");
      });
      restrictionSids = this.get("restrictionSet").get("restrictions").map(function(selector) {
        return selector.get("left").get("sid");
      });
      _(categorySids).chain().difference(newTrendSids).each(_.bind(function(sidToDelete) {
        return this.get("categorySet").removeCategoryBySid(sidToDelete);
      }, this));
      return _(restrictionSids).chain().difference(newTrendSids).each(_.bind(function(sidToDelete) {
        return this.get("restrictionSet").removeRestrictionBySid(sidToDelete);
      }, this));
    },
    relations: [
      {
        type: Backbone.HasOne,
        key: "restrictionSet",
        relatedModel: "rjm.model.RestrictionSet",
        includeInJSON: true
      }, {
        type: Backbone.HasOne,
        key: "categorySet",
        relatedModel: "rjm.model.CategorySet"
      }, {
        type: Backbone.HasOne,
        key: "cohortDescriptor",
        relatedModel: "rjm.model.CohortDescriptor",
        includeInJSON: true
      }, {
        type: Backbone.HasOne,
        key: "trend",
        relatedModel: "rjm.model.BaseTrend",
        includeInJSON: true
      }
    ],
    toJSON: function() {
      var r;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      r = this.unbindEnumsFromAttributes(r);
      return r;
    },
    changeCohortField: function(newCohortField) {
      this.get("cohortDescriptor").set({
        cohortField: newCohortField
      }, {
        silent: true
      });
      if (!newCohortField.get("canCountMembers")) {
        this.set({
          dataPerspective: rjm.app.enums.dataPerspective.STANDARD
        }, {
          silent: true
        });
      }
      if (this.get("cohortDescriptor")._changes.length > 0) {
        this.get("cohortDescriptor").change();
      }
      if (this._changes.length > 0) {
        this.change();
      }
      this.trigger("change", this);
    }
  });

  rjm.model.SeriesList = Backbone.Collection.extend({
    initialize: function() {
      return _.bindAll(this, "getTrendIds");
    },
    model: rjm.model.Series,
    getTrendIds: function() {
      var trendIds;
      trendIds = new Array();
      this.each(function(series) {
        return trendIds.push(series.get("trend").get("id"));
      });
      return trendIds;
    }
  });

}).call(this);
